import Typography from "@/src/views/components/Typography";
import styles from "./index.module.scss";
import AccountIcon from "@/src/views/components/Icon/icons/AccountIcon";
import { ShowcaseProduct, WordStyling } from "@/src/types/landingPage";
import { useEffect, useRef } from "react";

export default function ProductDetail({
  product,
  listWordStyling,
}: {
  product: ShowcaseProduct;
  listWordStyling: WordStyling[];
}) {
  const circleLineRef = useRef(null);
  const productDetailRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (circleLineRef.current) {
      observer.observe(circleLineRef.current);
    }
    if (productDetailRef.current) {
      observer.observe(productDetailRef.current);
    }
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    circleLineRef,
    productDetailRef,
    imageRef,
  ]);
  
  return (
    <div className={styles.content_container}>
      <div
        ref={circleLineRef}
        className={styles.circle_line_wrapper}
      >
        <div className={styles.circle_wrapper}>
          <div className={styles.circle} />
        </div>
        <div className={styles.line} />
      </div>
      <div className={styles.box_card}>
        <div
          ref={productDetailRef}
          className={styles.information_wrapper}
        >
          <Typography variant='subtitle-5-bold' color='dark40' >
            {product.nama_produk}
          </Typography>
          <div className={styles.lozenge}>
            <Typography variant={'subtitle-4-demibold'} color={'green100'} >
              {product.tipe_produk}
            </Typography>
          </div>
          <Typography variant={'title-2-medium'} color={'light80'} listWordStyling={listWordStyling}>
            {product.deskripsi_produk}
          </Typography>
          <div className={styles.owner_wrapper}>
            <AccountIcon />
            <Typography variant={'title-4-semibold'} color={'dark30'} >
              {product.product_owner}
            </Typography>
          </div>
        </div>
        <img
          ref={imageRef}
          className={styles.image_thumbnail}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/${product.thumbnail_produk}`}
        />
      </div>
    </div>
  );
}
